import { SdkContext } from '../internal'
import type { LogFilters, LogItem, LogPage } from '@/types/logs'

/** Drops empty filters so the query string carries only what was chosen. */
const cleanQuery = (params: Record<string, unknown>): Record<string, unknown> =>
  Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''))

/**
 * `getLogs`: everything the community records, newest first, merged by the
 * API across team, platform, assistant (MCP), members, e-mails, imports,
 * financial and moderation. Owner/admin read every type; finance only
 * `financial` (403 for the others).
 */
export class LogsResource {
  constructor(private ctx: SdkContext) {}

  async list(params: LogFilters & { page?: number; limit?: number } = {}): Promise<LogPage> {
    const result = await this.ctx.raw<LogItem[] | (Partial<LogPage> & { data?: LogItem[] })>(
      { httpMethod: 'GET', path: '/logs' },
      { query: cleanQuery({ ...params }) }
    )
    const limit = params.limit ?? 20
    if (Array.isArray(result)) {
      return { items: result, pagination: { page: 1, limit, total: result.length, totalPages: 1 } }
    }
    const items = result?.items || result?.data || []
    return {
      items,
      pagination: result?.pagination || { page: 1, limit, total: items.length, totalPages: 1 }
    }
  }
}
